import React, { useEffect } from "react";
import { Form, Input } from "antd";
import FormItem from "components/fields/FormItem";
import TextArea from "antd/es/input/TextArea";
import { useDispatch } from "react-redux";
import {
  doApproveAward,
  doDeclineAward,
} from "../../../../../redux/employeeaward/employeeAwardState";
import { MODULE_APPROVAL_AWARDS } from "variables/constants";
import CrudButtons from "components/button/crudbuttons";
import { requiredField } from "utils/crudSagaHelper";
import {
  CircleCheck, CircleX
} from "lucide-react"

const AwardApprovalForm = ({
  recordData,    
  mode = "edit",
  action,     
  onCancel,
}) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const doApprove = (data) => dispatch(doApproveAward(data));
  const doDecline = (data) => dispatch(doDeclineAward(data));

  useEffect(() => {
    if (recordData) {
      form.setFieldsValue({
        ema_id: recordData.ema_id,
        ema_status_id: recordData.ema_status_id,
      });
    }
  }, [recordData, form]);

  const onSubmit = (formData) => {
    try {
      const awardId = formData.ema_id ?? recordData?.ema_id;

      if (awardId > 0) {
        formData.recordId = awardId;
        formData.typeName = action;

        if (action === "Approve") {
          doApprove(formData);
        } else if (action === "Reject") {
          doDecline(formData);
        }
      }
    } catch (error) {
      console.error("Save failed:", error);
    }
  };


  const submitIcon = action === "Approve" ? <CircleCheck /> : <CircleX />;

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 text-[13px] py-4">
        <div className="pl-4">
          <p className="text-slate-700 mb-1 dark:text-slate-200">Nominated By</p>
          <span className="font-medium">
            {recordData?.nominator_name}
          </span>
        </div>
        <div>
          <p className="text-slate-700 mb-1 dark:text-slate-200">Award Category</p>
          <span className="font-medium">
            {recordData?.award_title}
          </span>
        </div>
      </div>

      <Form
        form={form}
        layout="vertical"
        onFinish={onSubmit}
      >
        <FormItem name="ema_id" hidden>
          <Input type="hidden" />
        </FormItem>
        
        <div className="grid grid-cols-1 px-4">
          <FormItem
            name="ema_note"
            label={
              action === "Reject"
                ? "Reason for Rejection"
                : "Additional Notes (Optional)"
            }
            rules={
              action === "Reject"
                ? [requiredField()]
                : []
            }
          >
            <TextArea
              id="ema_note"
              className="input-field"
              maxLength={255}
              placeholder={
                action === "Reject"
                  ? "Provide a reason for rejecting this request..."
                  : "Add any additional notes..."
              }
            />
          </FormItem>
        </div>

        <div className="px-4">
          {mode === "edit" && (
            <CrudButtons
              mode={mode}
              recordId={recordData?.ema_id ?? 0}
              isModal={true}
              modalId={`edit_nomination_${action.toLowerCase()}_${recordData?.ema_id}`}
              cancelLabel="Cancel"
              doHideModal={onCancel}
              submitLabel={`${action} Request`}
              submitIcon={submitIcon} 
              moduleId={MODULE_APPROVAL_AWARDS}
            />
          )}
        </div>
      </Form>
    </div>
  );
};

export default AwardApprovalForm;
